import React from "react";
import "../../../css/common.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faSquare } from "@fortawesome/free-solid-svg-icons";

const Collapsible = ({
  title,
  id,
  isOpen,
  onToggle,
  disabled = false,
  errorMessage,
  children,
  onCheck = () => {},
  checked = false,
  openText = "See Example",
  closeText = "Hide Example",
}) => {
  return (
    <div className={`collapsible-container`}>
      <div className={`collapsible-header ${disabled ? "disabled" : ""}`}>
        <div
          className={`collapsible-checkbox ${disabled ? "disabled" : ""}`}
          onClick={disabled ? null : () => onCheck(id)}
        >
          {checked ? (
            <FontAwesomeIcon
              style={{ fontSize: "20px", pointerEvents: "none" }}
              className="fas-checkbox-checked"
              icon={faCheckSquare}
            />
          ) : (
            <FontAwesomeIcon
              style={{ fontSize: "20px", pointerEvents: "none" }}
              className="fas-checkbox-unchecked dark-gray-text"
              icon={faSquare}
            />
          )}
        </div>

        <span
          className="collapsible-title"
          onClick={disabled ? null : () => onCheck(id)}
        >
          {title}
        </span>
        {!disabled && (
          <button className="toggle-button" onClick={() => onToggle(id)}>
            {isOpen ? closeText : openText}
          </button>
        )}
      </div>
      {isOpen && !disabled && (
        <div className="collapsible-body">{children}</div>
      )}
      {disabled && errorMessage && (
        <div className="collapsible-error-message">{errorMessage}</div>
      )}
    </div>
  );
};

export default Collapsible;
